import CardDropdown from 'components/common/CardDropdown';
import FalconCardHeader from 'components/common/FalconCardHeader';
import React from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import FalconCardFooterLink from 'components/common/FalconCardFooterLink';
import Flex from 'components/common/Flex';
import classNames from 'classnames';
import Avatar from 'components/common/Avatar';
import { Link } from 'react-router-dom';
import { weRelatedContacts } from 'data/weraise-data/donar-data';

const RelatedContacts = () => {
  const end = 7;
  return (
    <Card>
      <FalconCardHeader
        title={<h4 className="fw-bold">Related Contacts</h4>}
        light={false}
        titleTag="div"
        className="pb-1"
        menuClassName="align-items-start"
        endEl={<CardDropdown btnRevealClass="btn-falcon-default" />}
      />
      <Card.Body className="py-2">
        {weRelatedContacts.slice(0, end).map(({ id, ...rest }, index) => (
          <ActiveUser
            {...rest}
            key={id}
            isLast={index === weRelatedContacts.length - 1}
          />
        ))}
      </Card.Body>
      <FalconCardFooterLink
        title="See more contacts"
        to="#"
        size="sm"
        className={'bg-transparent'}
        btnClassName={'w-auto text-700'}
        showArrow={false}
      />
    </Card>
  );
};

const ActiveUser = ({ name, avatar, role, isLast }) => (
  <Flex
    className={classNames('align-items-center', {
      'border-bottom mb-2 pb-2 border-200': !isLast
    })}
  >
    <Avatar
      {...avatar}
      // className={`status-${avatar.status}`}
    />
    <div className="ms-3">
      <h6 className="mb-0 fw-semi-bold">
        <Link className="text-900" to={`/donors/${name}`}>
          {name}
        </Link>
      </h6>
      <p className="text-500 fs--2 mb-0">{role}</p>
    </div>
  </Flex>
);

ActiveUser.propTypes = {
  name: PropTypes.string.isRequired,
  avatar: PropTypes.object,
  role: PropTypes.string,
  isLast: PropTypes.bool
};

RelatedContacts.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape(ActiveUser.propTypes)),
  end: PropTypes.number
};

export default RelatedContacts;
